import { render, staticRenderFns } from "./LotCard.vue?vue&type=template&id=27230676&scoped=true&"
import script from "./LotCard.vue?vue&type=script&lang=js&"
export * from "./LotCard.vue?vue&type=script&lang=js&"
import style0 from "./LotCard.vue?vue&type=style&index=0&id=27230676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27230676",
  null
  
)

export default component.exports